export default __webpack_public_path__ + "static/media/arena_15.f9cca527.jpeg";